import { faCircleArrowLeft, faXmark } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import { match } from 'ts-pattern';

import { AskIQHeading } from 'lib/common/contexts/AIContext/components/common/AskIQHeading/AskIQHeading';

import ClickableIcon from 'lib/common/components/ClickableIcon';
import Text from 'lib/common/components/Text';

import { useAIContext } from '../../../Context';
import { IQActionItems } from '../../IQActionsMenu/constants/IQActionItems';
import SlideInEffect from '../../common/SlideInEffect/SlideInEffect';
import { TIQDisplayMode } from '../../constants/IQDisplayMode';

import styles from './iq-menu-container-header.module.scss';

export default function IQMenuContainerHeader({ displayMode }: { displayMode: TIQDisplayMode }) {
  const {
    actions: { closeActionMenu, selectAction, selectMode, resetIQApiState },
    state: { selectedAction, selectedMode },
  } = useAIContext();

  const navigateToMainMenu = () => {
    resetIQApiState();
    selectAction(null);
    selectMode(null);
  };
  const navigateBack = () => {
    resetIQApiState();
    selectMode(null);
  };

  const backButtonAction = selectedMode ? navigateBack : navigateToMainMenu;

  const selectedActionTitle = Object.values(IQActionItems).find((item) => item.actionID === selectedAction)?.title[
    displayMode
  ];
  const displayModeLower = displayMode.toLowerCase();

  return (
    <div className={cx(styles['iq-menu-container-header'], styles[`iq-menu-container-header--${displayModeLower}`])}>
      <div className={styles['iq-menu-container-header__title--container']}>
        {selectedAction && (
          <SlideInEffect direction="right">
            <ClickableIcon size={15} icon={faCircleArrowLeft} onClick={backButtonAction} />
          </SlideInEffect>
        )}
        <Text type="heading3" className={styles['iq-menu-container-header__title']}>
          {selectedActionTitle ? (
            <SlideInEffect direction="right">{selectedActionTitle}</SlideInEffect>
          ) : (
            <AskIQHeading />
          )}
        </Text>
      </div>
      <SlideInEffect direction="left">
        <ClickableIcon size={15} icon={faXmark} onClick={closeActionMenu} />
      </SlideInEffect>
    </div>
  );
}
